import { FC, Fragment, PropsWithChildren } from "react";
import { Navigate } from "react-router-dom";
import { useSupabaseAuth } from "../supabase/SupabaseContext";
import { Role } from "../types/entities";
import RequireAuth from "./RequireAuth";

// Wraps RequireAuth with a role check. `anyOf` — the member needs at least
// one of the listed roles (e.g. fines mutations allow kasserer OR admin).
const RequireRole: FC<PropsWithChildren<{ anyOf: Role[] }>> = ({ anyOf, children }) => {
  const { hasRole, isLoading } = useSupabaseAuth();

  return (
    <RequireAuth>
      {isLoading ? null : anyOf.some((role) => hasRole(role)) ? (
        <Fragment>{children}</Fragment>
      ) : (
        <Navigate to="/" replace />
      )}
    </RequireAuth>
  );
};

export default RequireRole;
